export function QuestionIcon( { className }: { className?: string } ) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M8 11.875C8.34518 11.875 8.625 11.5952 8.625 11.25C8.625 10.9048 8.34518 10.625 8 10.625C7.65482 10.625 7.375 10.9048 7.375 11.25C7.375 11.5952 7.65482 11.875 8 11.875Z"
                fill="var(--ui-content-t3)"
            />
            <path
                d="M8 9V8.5C9.10438 8.5 10 7.71625 10 6.75C10 5.78375 9.10438 5 8 5C6.89562 5 6 5.78375 6 6.75V7"
                stroke="var(--ui-content-t3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z"
                stroke="var(--ui-content-t3)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
